module.exports = __webpack_public_path__ + "static/img/SA.9d35b7d4.png";